<div class="wizard-navigation-container" [ngClass]="{'fixed-navigation-mobile': !isStartStep}">
  <div class="navigation-button-container">
    <span *ngIf="!hideBackButton" class="back-button-container">
      <app-back-button
        [currentStepName]="currentStepName"
        [previousStepRoute]="previousStepRoute"
        [previousStepNumber]="getPreviousStepNumber()"
        [totalSteps]="totalSteps"></app-back-button>
    </span>
    <app-continue-button
      [currentStepName]="currentStepName"
      [isStartStep]="isStartStep"
      [nextStepRoute]="nextStepRoute"
      [nextStepNumber]="getNextStepNumber()"
      [totalSteps]="totalSteps"
      [disableContinueButton]="disableContinueButton"></app-continue-button>
  </div>
</div>
